
<template>
  <div class="speech-bubble onboardingbutton" v-html="element.text" v-if="!limit || (element.limit && step.answers.length > element.limit)" @click="clicked" v-bind:id="'button' + getId()" v-bind:class="getClass(element)" style="position:relative;">
  </div>
</template>

<script>
  export default {
    name: 'onboarding-button',
    components: {
    },
    props: {
      element: {
        required: false,
        type: Object,
        default() {
          return { extra: null, animation:""}
        }
      },
      step: {
        required: false,
        type: Object,
        default() {
          return null
        }
      },
    },
    data() {
      return {
      }
    },
    methods: {
      getClass(element) {
        var classString = element.animation;
        if (element.limit && this.step.answers && this.step.answers.length < element.limit)
          classString += " disabled";
        else
          classString += " active";
        return classString;
      },
      clicked() {
        if (this.element.limit && this.step.answers < this.element.limit)
          return;

        this.$emit("buttonclick", this.element, this.step)
        var thisContext = this;
        setTimeout(function () {
          if (thisContext.element.goto) {
            thisContext.$emit("goto", thisContext.element.goto)
          }
        }, 1);
        

      },
      getId() {
        return this._uid;
      },
      hide() {
        $('#button' + this.getId()).hide();
      },
      show() {
        $('#button' + this.getId()).show();
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>


  .speech-bubble {
    position: relative;
    
    border-radius: .4em;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    font-size: 24px;
    color: white;
    float: right;
    right: 30px;
    max-width: 60%;
  }

  .speech-bubble.active {
    background: #349526;
    cursor: pointer;
  }

  .speech-bubble.disabled {
    background: #c7c7c7;
    cursor:not-allowed;
  }


  @media (max-width: 768px) {
    .speech-bubble {
      font-size: 18px;
    }
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }


  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }

  .duration-15 {
    animation-duration: 15s;
  }

</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-button.vue